import React from "react";

export default function WishesItem(props) {
  const { nama, ucapan } = props;
  return (
    <>
      <p className="wishes-item-name">{nama}</p>
      <i className="wishes-item-word">{ucapan}</i>
    </>
  );
}
